import { HealthcareSessionId } from '@hc-frontend/core-types';
import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { PostSessionResponseDTO, UpdateSessionPayloadDTO } from '../../dto';
import type { UpdateSessionOptions } from './update-session.types';

export function updateSession(
  baseUrl: string,
  sessionId: HealthcareSessionId,
  payload: UpdateSessionPayloadDTO,
  options?: UpdateSessionOptions<UpdateSessionPayloadDTO>,
): Promise<IHttpResponse<PostSessionResponseDTO>> {
  const call = options?.httpCall ?? fetchBasedCall;

  const request: IHttpRequest<UpdateSessionPayloadDTO> = {
    url: `${baseUrl}/session/${sessionId}`,
    method: 'POST',
    body: payload,
    ...options?.requestOverride,
    schemas: {
      request: UpdateSessionPayloadDTO,
      response: PostSessionResponseDTO,
    },
  };

  return call(request);
}
